import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import UserProfile from "@/pages/UserProfile.vue";
import TableList from "@/pages/TableList.vue";
import DetallePedido from "@/pages/DetallePedido.vue";
import Typography from "@/pages/Typography.vue";
import Icons from "@/pages/Icons.vue";
import Maps from "@/pages/Maps.vue";
import Notifications from "@/pages/Notifications.vue";
import UpgradeToPRO from "@/pages/UpgradeToPRO.vue";
import EditarPedido from "@/pages/EditarPedido.vue";
import NuevaSena from "@/pages/NuevaSena.vue";
import Login from "@/pages/Login.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard
      },
      {
        path: "nuevo-pedido",
        name: "Nuevo Pedido",
        component: UserProfile
      },
      {
        path: "pedidos",
        name: "Pedidos",
        component: TableList
      },
      {
        path: "pedidos/:id",
        name: "Pedido Detalle",
        component: DetallePedido
      },
      {
        path: "caja",
        name: "Caja",
        component: Typography
      },
      {
        path: "gestionar-fecha",
        name: "Gestionar Fecha",
        component: Maps
      },
      {
        path: "nueva-sena/:id",
        name: "Sena",
        component: NuevaSena
      },
      {
        path: "consultar-fecha",
        name: "Consultar Fechas",
        component: Icons
      },
      {
        path: "editar-pedido/:id",
        name: "Editar Pedido",
        component: EditarPedido
      },
      {
        path: "login",
        name: "Login",
        component: Login
      },
      { path: "/", component: Dashboard }
    ]
  }
];

export default routes;
